import { Slot } from "@radix-ui/react-slot";
import { cva } from "class-variance-authority";
import * as React from "react";

import { cn } from "../lib/cn";

const underlineTabListVariants = cva(
  "-mx-4 flex items-center gap-6 overflow-x-auto px-4",
);

const underlineTabVariants = cva(
  "a11y-focus inline-flex shrink-0 cursor-pointer border-b-[1.5px] pb-[1.5px] font-medium text-base leading-6 capitalize transition-colors",
  {
    variants: {
      active: {
        true: "",
        false: "",
      },
    },
    compoundVariants: [
      {
        active: true,
        className: "border-white text-white",
      },
      {
        active: false,
        className: "border-transparent text-white/45 hover:text-white/70",
      },
    ],
    defaultVariants: {
      active: false,
    },
  },
);

export interface UnderlineTabListProps
  extends React.HTMLAttributes<HTMLDivElement> {}

export interface UnderlineTabProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  active?: boolean;
  asChild?: boolean;
}

const UnderlineTabList = React.forwardRef<
  HTMLDivElement,
  UnderlineTabListProps
>(({ className, ...props }, ref) => {
  return (
    <div
      ref={ref}
      className={cn(underlineTabListVariants({ className }))}
      {...props}
    />
  );
});
UnderlineTabList.displayName = "UnderlineTabList";

const UnderlineTab = React.forwardRef<HTMLButtonElement, UnderlineTabProps>(
  ({ className, active, asChild = false, ...props }, ref) => {
    const Comp = asChild ? Slot : "button";

    return (
      <Comp
        ref={ref}
        className={cn(underlineTabVariants({ active, className }))}
        {...props}
      />
    );
  },
);
UnderlineTab.displayName = "UnderlineTab";

export {
  UnderlineTab,
  UnderlineTabList,
  underlineTabListVariants,
  underlineTabVariants,
};
